const formatDate = (dateString: string | null): string => {
  if (!dateString) {
    return '';
  }
  const date = new Date(dateString);

  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export default formatDate;
